import { render, staticRenderFns } from "./TestProperties.vue?vue&type=template&id=1f81d49f&scoped=true"
import script from "./TestProperties.vue?vue&type=script&lang=ts"
export * from "./TestProperties.vue?vue&type=script&lang=ts"
import style0 from "./TestProperties.vue?vue&type=style&index=0&id=1f81d49f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81d49f",
  null
  
)

export default component.exports